"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSiteMapLayerService = exports.default_layer_icon = exports.default_layer_color = exports.layer_color_options = exports.layer_icon_options = exports.LayerIcon = void 0;
var React = require("react");
var immer_1 = require("immer");
var urls_1 = require("../urls");
var RestData_1 = require("../rest/RestData");
var utils_1 = require("../utils");
var LayerIcon;
(function (LayerIcon) {
    LayerIcon["PIN"] = "marker";
    LayerIcon["CIRCLE"] = "circle";
    LayerIcon["BOX"] = "box";
})(LayerIcon = exports.LayerIcon || (exports.LayerIcon = {}));
exports.layer_icon_options = [
    [LayerIcon.PIN, gettext("pin")],
    [LayerIcon.CIRCLE, gettext("circle")],
    [LayerIcon.BOX, gettext("box")],
];
exports.layer_color_options = [
    ["#7D83FF", "blue"],
    ["#05E1DD", "teal"],
    ["#70b233", "green"],
    ["#20C406", "bright green"],
    ["#BE7DFF", "purple"],
    ["#6f05e1", "dark purple"],
    ["#FF8D7D", "light red"],
    ["#A6A615", "brown"],
    ["#E16905", "bright red"],
    ["#D5B8E5", "light purple"],
];
exports.default_layer_color = "#7D83FF";
exports.default_layer_icon = LayerIcon.PIN;
var initial_data = [];
var SiteLayerAction;
(function (SiteLayerAction) {
    SiteLayerAction["CHANGE_DATA"] = "CHANGE_DATA";
})(SiteLayerAction || (SiteLayerAction = {}));
function site_map_layers_data_reducer(state, action) {
    if (action.type == RestData_1.DataActionType.LIST_POST) {
        return action.payload;
    }
    if (action.type == RestData_1.DataActionType.DELETE_POST) {
        return (0, immer_1.default)(state, function (draft) {
            var index = (0, utils_1.findIndexById)(draft, action.object_id);
            draft.splice(index, 1);
        });
    }
    if (action.type == RestData_1.DataActionType.CREATE_POST) {
        return (0, immer_1.default)(state, function (draft) {
            draft.push(action.payload);
        });
    }
    if (action.type == RestData_1.DataActionType.UPDATE_POST) {
        return (0, immer_1.default)(state, function (draft) {
            var index = (0, utils_1.findIndexById)(draft, action.object_id);
            draft[index] = action.payload;
        });
    }
    if (action.type == SiteLayerAction.CHANGE_DATA) {
        return (0, immer_1.default)(state, function (draft) {
            var index = (0, utils_1.findIndexById)(draft, action.object_id);
            if (index != -1) {
                Object.keys(action.updates).forEach(function (name) {
                    draft[index][name] = action.updates[name];
                });
            }
        });
    }
    return state;
}
function useSiteMapLayerService(project_id) {
    var _a = __read(React.useReducer(site_map_layers_data_reducer, initial_data), 2), site_map_layers_data = _a[0], dispatch = _a[1];
    var rest_svc = (0, RestData_1.useRestData)((0, urls_1.resolve)(urls_1.Urls.admin_site_map_layers, project_id), dispatch);
    function change_layer_data(layer_id, name, value) {
        var _a;
        dispatch({
            type: SiteLayerAction.CHANGE_DATA,
            payload: undefined,
            object_id: layer_id,
            updates: (_a = {},
                _a[name] = value,
                _a),
        });
    }
    return [
        site_map_layers_data,
        __assign(__assign({}, rest_svc), { change_data: change_layer_data }),
    ];
}
exports.useSiteMapLayerService = useSiteMapLayerService;
